import ApiClientProject from './apiClientProject'
import { useAuthStore } from './authStore'

// Vytvoríme jedinú inštanciu ApiClientProject pre celú aplikáciu
const apiClientProject = new ApiClientProject()

// Pri prvom načítaní aplikácie nastavíme token z `authStore`
const auth = useAuthStore.getState().auth
apiClientProject.setAuthToken(auth?.token ?? null)

// Počúvame na zmeny v `authStore` a aktualizujeme `apiClientProject`
useAuthStore.subscribe((state) => {
  apiClientProject.setAuthToken(state.auth?.token ?? null)
})

/**
 * Hook to get the api instance (Nest /project doc, apiClientProject).
 * Synchronizuje token zo store pri každom renderi, čím sa vyhne race condition
 * keď hasAuthToken je už true, ale client ešte nemal token.
 */
export function useApiClientProject() {
  const auth = useAuthStore((state) => state.auth)
  // Sync token pred vrátením - zaručí, že client má token keď ho komponent použije
  apiClientProject.setAuthToken(auth?.token ?? null)
  return apiClientProject.apiInstance
}
